











import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    computed: {
        ...mapCustomLabelsState(['portalTitle', 'instanceTitle']),
    },
    created() {
        const portalTitle = this.portalTitle;
        const instanceTitle = this.instanceTitle;
        document.title = `${instanceTitle} | ${this.$t('htmlTitle', { instanceTitle, portalTitle }) as string}`;
    },
});
